import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';

import { useAppSelector } from 'store/hooks';
import OwnerOperate from '../OwnerOperate';
import RewardsCount from '../RewardsCount';

interface IBuyInfoProps {}

const Time = dynamic(() => import('@/components/RaffleDetails/BuyInfo/Time'), {
  ssr: false,
});

const BuyInfo: React.FC<IBuyInfoProps> = ({}) => {
  const {
    raffleInfo: { status },
  } = useAppSelector((state) => state.raffleDetails);

  const [raffleStatus, setRaffleStatus] = useState('');

  useEffect(() => {
    setRaffleStatus(String(status));
  }, [status]);

  if (raffleStatus === 'FINALIZED' || raffleStatus === 'ENDED') {
    return null;
  }

  return (
    <div className="mt-8 lg:mt-0">
      <OwnerOperate />
      <RewardsCount />
      <div className="mb-5 rounded-2xl border border-neutral-600 px-5 py-6">
        <Time />
      </div>
    </div>
  );
};

export default BuyInfo;
